/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { ShowClipping, getClipping } from 'services/actions/get_curriculum';
import Select from 'react-select';
import Loader from 'components/atoms/loader';

interface Clipping {
  name: string;
  value: string;
}

const Clippings: React.FC = () => {
  const [clipping, setClipping] = useState<Array<Clipping>>([]);
  const [clippingSelected, setClippingSelected] = useState<string>('');
  const [file, setFile] = useState<any>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Clipping - ConLicitação';
    (async () => {
      const clipping = await getClipping();
      setClipping(clipping?.data);
    })();
  }, []);

  useEffect(() => {
    setFile('');
    (async () => {
      if (clippingSelected !== '') {
        const file = await ShowClipping(clippingSelected);
        setLoading(file?.status !== 200);
        setFile(file?.data);
      }
    })();
  }, [clippingSelected]);

  return (
    <div className="col-md-9 mt-md-0 mt-3">
      <h4 className="font-weight-bold">Clipping Polícia Federal</h4>
      <div className="col-md-4 px-0">
        <Select
          name="role"
          className="mt-3"
          options={clipping?.map((clipping) => {
            return {
              label: clipping?.value,
              value: clipping?.name,
            };
          })}
          noOptionsMessage={() => 'Selecionar'}
          placeholder="Selecione uma data"
          onChange={(value) => setClippingSelected(String(value?.value))}
        />
      </div>
      <div>
        {loading ? <Loader /> : <div className="mt-5" dangerouslySetInnerHTML={{ __html: file }} />}
      </div>
    </div>
  );
};
export default Clippings;
